import * as Notifications from 'expo-notifications';
import * as Device from 'expo-device';
import { Platform } from 'react-native';
import Constants from 'expo-constants';
import { useEffect } from 'react';
import useUserDevicePushTokens from './api/useUserDevicePushTokens';

Notifications.setNotificationHandler({
    handleNotification: async () => ({
        shouldShowBanner: true,
        shouldShowList: true,
        shouldPlaySound: true,
        shouldSetBadge: true,
    }),
});

async function registerForPushNotificationsAsync() {
    if (Platform.OS === 'android') {
        Notifications.setNotificationChannelAsync('default', {
            name: 'default',
            importance: Notifications.AndroidImportance.MAX,
            vibrationPattern: [0, 250, 250, 250],
            lightColor: '#FF231F7C',
        });
    }

    if (Device.isDevice) {
        const { status: existingStatus } = await Notifications.getPermissionsAsync();
        let finalStatus = existingStatus;
        if (existingStatus !== 'granted') {
            const { status } = await Notifications.requestPermissionsAsync();
            finalStatus = status;
        }
        if (finalStatus !== 'granted') {
            console.error('Failed to get push token for push notifications');
            return;
        }
        const projectId = Constants?.expoConfig?.extra?.eas?.projectId ?? Constants?.easConfig?.projectId;
        if (!projectId) {
            console.error('Project ID not found');
            return;
        }
        try {
            const pushTokenString = (
                await Notifications.getExpoPushTokenAsync({
                    projectId,
                })
            ).data;
            return pushTokenString;
        } catch (e: unknown) {
            console.error('Failed to get push token for push notifications', e);
        }
    } else {
        console.warn('Push notifications are not supported in the simulator or web');
    }
}

/**
 * Hook to register the device push token for push notifications.
 */
export const useRegisterDevicePushToken = () => {
    const { registerDevicePushToken } = useUserDevicePushTokens();

    useEffect(() => {
        if (Platform.OS === 'web') return;

        registerForPushNotificationsAsync()
            .then((pushToken) => {
                if (pushToken) {
                    registerDevicePushToken(pushToken);
                }
            })
            .catch((e) => {
                console.error('Failed to register device push token', e);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
